module.exports = __webpack_public_path__ + "img/usersNewOrder.2b1ab534.jpg";